// css文件中不要使用import
import '../css/uplive/index.less';

import './lib/babel-polyfill';
import './lib/promise';
import './base/html5';
import './base/global';
import './lang/index';
import './component/SM/index';
import React, { Component } from 'react';
window.React = React;

import ReactDOM, { render } from 'react-dom';
import Cache from 'c-cache';
import { Router, IndexRoute, Route, hashHistory, browserHistory, useRouterHistory } from 'react-router';
import { createHistory } from 'history'
import Url from 'c-url';
import Fastclick from 'c-fastclick';
import getTargetUrl from './lib/util/geturl';
import sensitive from './component/sensitive-words';
import './base/video';

import lang from './lang';
import AppHoc from './hoc';
import routes from './routes';
import DA from './component/data-analytics';
import './component/data-analytics/fb-pixel';
// import './component/vas/index';
import GDN from './component/GDN';
FastClick.attach(document.body);

/**
 * 开发环境用hashHistory，线上环境用browserHistory，window.hashHistory名称仅仅为了不修改其他模块的代码
 */
window.dev = Url.query('dev') == 1;
window.hashHistory = window.dev == 1 ? hashHistory : useRouterHistory(createHistory)({
    basename: location.pathname.indexOf('/uplive-pc/') > -1 ? location.pathname.substr(0, location.pathname.indexOf('/uplive-pc/') + '/uplive-pc/'.length) : '/'
});
window.hashHistory.oldPush = window.hashHistory.push;
window.hashHistory.push = function(path) {
    if (window.dev) {
        window.hashHistory.oldPush(path);
    } else {
        let params = {};

        if (typeof path == 'string') {
            params = {
                pathname: path,
                search: location.search
            }
        } else {
            path.search = path.search || location.search;
            params = path;
        }

        window.hashHistory.oldPush(params);
    }
};
window.hashHistory.listen(location => {
    //console.log(location) // /home
})


if (UP.Global.version !== 'CN') {
    GDN.init();
}

const cache = new Cache({
    prefix: 'pcuplive'
});

UP.Global.openInNewTab = function(path) {
    if (path.match(/^(https?\:\/\/)/)) {
        if (Url.query('singleWindow')) {
            location.href = path;
        } else {
            window.open(path);
            window.focus();
        }
    } else {
        if (Url.query('singleWindow')) {
            window.hashHistory.push(path);
        } else {
            let url = location.protocol + '//' + location.hostname + window.hashHistory.createHref(path) + location.search + location.hash;

            window.open(url);
            window.focus();
        }
    }
}

UP.Global.DA = DA;


function createElement(Component, props) {
    if (props.location.action == 'POP') {
        // 保留当前路由path
        UP.Global.currentPathName = props.location.pathname;
    }

    // 确保传入了所有的 props！
    return <Component {...props}/>
}

class App extends Component {
    static defaultProps = {};

    constructor(props) {
        super(props);

        document.title = lang.template('页面标题');
    }

    componentDidMount() {
        sensitive.getDataFromServer();
    }

    render() {
        return (
            <Router history={window.hashHistory} routes={routes} createElement={createElement}></Router>
        );
    }
}


const paidfrom = Url.query('paidfrom');


if (paidfrom) {
    // 支持成功之后对URL参数处理。备注：充值成功之后会在URL后追加参数
    let url;

    cache.removeCache('_u_paid');
    cache.removeCache('_u_paidret');
    cache.removeCache('_u_paid_channel');

    cache.setCache('_u_paid', Url.query('productId'));
    cache.setCache('_u_paid_channel', Url.query('channel'));

    const resultCode = Url.query('result_code');
    
    if (resultCode) {
        const isSuccess = resultCode == 'SUCCESS' ?  1 : 0;
        cache.setCache('_u_paidret', [Url.query('productId'), isSuccess].join('/'));
    }

    if (window.dev) {
        if (location.href.indexOf('?paidfrom=') > -1) {
            url = location.href.split('?paidfrom=')[0];
        } else {
            url = location.href.split('&paidfrom=')[0];
        }
        location.replace(url + '#' + decodeURIComponent(paidfrom));
    } else {
        url = getTargetUrl(location.href);
        location.replace(url);
    }


} else {

    var gameEnter = function() {
        let NewApp = AppHoc(App);
        render(<NewApp/>, $("#wrap")[0]);
    }

    // 无论是否使用游客，都产生一个smd（数美的deviceId）
    // 并且存储到本地
    let cacheDeviceId = cache.getCache('smDeviceId');

    if (!cacheDeviceId) {

        // 数美JS已经加载完成
        if (typeof SMSdk !== 'undefined') {
            window.smDeviceId = SMSdk.getDeviceId();
            cache.setCache('smDeviceId', window.smDeviceId);
            gameEnter();
        } else {
            // 否则监听事件，等待sdk加载完成
            $.channel.on('smsdkLoaded', () => {
                window.smDeviceId = SMSdk.getDeviceId();
                cache.setCache('smDeviceId', smDeviceId);
                gameEnter();
            });
        }
    } else {
        window.smDeviceId = cacheDeviceId;
        gameEnter();
    }
}


// WEBPACK FOOTER //
// ./js/app.js